import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import DashboardPage from "./pages/DashboardPage";
import HeaderLayout from "./layouts/HeaderLayout";
import ARGoodsRegistrationPage from "./pages/ARGoodsRegistrationPage";
import AuthPage from "./pages/AuthPage";
import UserSetupPage from "./pages/UserSetupPage";
import SidebarLayout from "./layouts/SidebarLayout";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        {/* ヘッダーのみの画面 */}
        <Route element={<HeaderLayout />}>
          <Route path="/" element={<AuthPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/user-setup" element={<UserSetupPage />} />
        </Route>

        {/* サイドバー付きの画面 */}
        <Route element={<SidebarLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/ar-goods-register" element={<ARGoodsRegistrationPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
